import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bulk-cancellation',
  templateUrl: './bulk-cancellation.component.html',
  styleUrls: ['./bulk-cancellation.component.css']
})
export class BulkCancellationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
